import React from 'react'

export default function AddCard() {
    return (
        <div>AddCard</div>
    )
}
